import styled from '@emotion/styled';
import Text from 'components/base/Text';

/**
 * 검색 결과 - 필터를 통한 조회 결과가 없는 경우 노출
 * @component
 */
const EmptyWithFilter = () => {
  return (
    <SC.Container>
      <Text variant='title5_bold' color='black' as='h2' mt={12}>
        필터 검색 결과가 없어요
      </Text>
      <Text variant='body3' color='gray700' as='h3' mt={10} mb={24}>
        필터를 변경해 보세요.
      </Text>
    </SC.Container>
  );
};

const SC = {
  Container: styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
  `,
};

export default EmptyWithFilter;
